module.exports = __webpack_public_path__ + "static/media/22.17da099d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/22.jpg
// module id = 391
// module chunks = 0